<div class="editor">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center"
      (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>

    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'"
      class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>


  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>


  <!-- --------------------------------------------------------- CẤU HÌNH CƠ BẢN --------------------------------------------------------- -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px;">
      <div class="field-row">
        <!-- Kiểu văn bản-->
        <div class="config-font" style="width:100%">
          <mat-form-field style="width:100%">
            <mat-label>{{'kieu_van_ban' | translate}}</mat-label>
            <mat-select [disabled]="class['text__content--list-style']['list-style'] != 'none'"
              [(ngModel)]="config['text_type']" (ngModelChange)="handleSetTextStyle($event)">
              <mat-option *ngFor="let item of text_style" [value]="item.name"
                [style.font-size.px]="item.font">{{item.title | translate}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Giải thích kiểu vãn bản -->
        <div class="explain-text-type">
          <ul class="explain-text-type__list">
            <li *ngFor="let item of seoTextTypes" style="font-size: 14px">
              <ng-container *ngIf="item.tag">
                - <b>{{ item.tag | translate }}</b> &#8594;
              </ng-container>
              <span>
                {{ item.explain | translate }} 
                <ng-container *ngIf="item.usage">
                  (<b style="color: red">{{ item.usage | translate }}</b>)
                </ng-container>
              </span>
            </li>
          </ul>
        </div>
      </div>
      
      <div *ngIf="!config.is_copyright" class="config-text" style="width: 100%">
        <mat-form-field style="width: 100%">
          <mat-label>{{'noi_dung' | translate}}</mat-label>
          <textarea matInput
            [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
            (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
            (blur)="handleChangeConfig()"></textarea>
        </mat-form-field>
      </div>

      <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
        [staticdata]="staticdata" [textContentClass]="class['text__content']"
        [textWrapperClass]="class['text__wrapper']">
      </app-text-format-config>
      <div class="config-name">
        <p>{{'xuong_dong' | translate}}</p>
        <nz-switch [ngModel]="class['text__wrapper']['white-space'] && class['text__wrapper']['white-space'] !== 'nowrap'"
        (ngModelChange)="class['text__wrapper']['white-space'] = $event ? 'pre-wrap' : 'nowrap';updateClass()"></nz-switch>
      </div>

      <app-link-page-config [objectChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [dynamic_data]="objectChoosing.dynamic_data" [hasContact]="true">
      </app-link-page-config>
    </div>
  </ng-container>


  <!-- -------------------------------------------------------- CẤU HÌNH NÂNG CAO -------------------------------------------------------- -->
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- ------------------------------------------------------------ HIỂN THỊ ------------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'hien_thi' | translate" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>


      <!-- ---------------------------------------------------------- CẤU HÌNH XOAY ---------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'cau_hinh_xoay' | translate" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['text']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing">
        </app-rotate-config>
      </li>

      <!-- ---------------------------------------------------------- CẤU HÌNH KHOẢNG ĐỆM ---------------------------------------------------------- -->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['text__content']" [paddingConfigs]="[
          { type: 'top' },
          { type: 'bottom' },
          { type: 'left' },
          { type: 'right' },
        ]">
        </app-padding-config>
      </li>

      <!-- ---------------------------------------------------------- CẤU HÌNH VIỀN ---------------------------------------------------------- -->
      <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMap.menu12"
        (nzOpenChange)="openHandler('menu12')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['text__content']" [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'bo_goc' | translate}} &#8594;
          </p>
        </div>
      </li>

      <!-- -------------------------------------------------------- CHỮ VÀ ĐỊNH DẠNG --------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'chu_va_dinh_dang' | translate" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <div class="editor-field-body">
            <!-- Văn bản có dấu -->
            <div class="field-row">
              <div class="config-name">
                <p>{{'van_ban_co_dau' | translate}} <span style="font-size:13px;color:red"> * </span></p>
                <nz-switch [(ngModel)]="config.icon.icon_check" (ngModelChange)="updateConfig()"></nz-switch>
              </div>
              <div class="text-icon" *ngIf="config.icon.icon_check">
                <div class="config-name">
                  <p>{{'mau_dau' | translate}} <span [style.color]="class['text__icon']['color']">*</span></p>
                  <div style="width:40%; max-width:40%">
                    <input class="input-color w-100" type="button" [style.background]="class['text__icon']['color']"
                      [cpOKButton]="true" [(colorPicker)]="class['text__icon']['color']"
                      (colorPickerClose)="updateClass()" />
                  </div>
                </div>
                <div class="config-font">
                  <div class="config-name mb-0">
                    <p>{{'khoang_cach' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['text__icon']['padding-right'] | vhnumber"
                      (ngModelChange)="class['text__icon']['padding-right'] = $event+'px'" (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <div>
                    <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                      [ngModel]="class['text__icon']['padding-right'] | vhnumber"
                      (ngModelChange)="class['text__icon']['padding-right'] = $event+'px'"
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                  <div class="config-font mb-4">
                    <p class="title">{{'canh_le_doc_dau' | translate}} *</p>
                    <div class="font">
                      <button class="font-text-btn" nz-button [disabled]="config['curve']['isCurve']"
                        [nzType]="class['text__icon']['align-items'] == 'flex-start' ? 'primary' : 'default'"
                        (click)="class['text__icon']['align-items'] = 'flex-start'; updateClass()">
                        <i nz-icon nzType="align-left" nzTheme="outline"></i>
                      </button>
                      <button class="font-text-btn" nz-button [disabled]="config['curve']['isCurve']"
                        [nzType]="class['text__icon']['align-items'] == 'center' ? 'primary' : 'default'"
                        (click)="class['text__icon']['align-items'] = 'center'; updateClass()">
                        <i nz-icon nzType="align-center" nzTheme="outline"></i>
                      </button>
                      <button class="font-text-btn" nz-button [disabled]="config['curve']['isCurve']"
                        [nzType]="class['text__icon']['align-items'] == 'flex-end' ? 'primary' : 'default'"
                        (click)="class['text__icon']['align-items'] = 'flex-end'; updateClass()">
                        <i nz-icon nzType="align-right" nzTheme="outline"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="field-row">
              <!-- Kiểu văn bản-->
              <div class="config-font" style="width:100%">
                <mat-form-field style="width:100%">
                  <mat-label>{{'kieu_van_ban' | translate}}</mat-label>
                  <mat-select [disabled]="class['text__content--list-style']['list-style'] != 'none'"
                    [(ngModel)]="config['text_type']" (ngModelChange)="handleSetTextStyle($event)">
                    <mat-option *ngFor="let item of text_style" [value]="item.name"
                      [style.font-size.px]="item.font">{{item.title | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Giải thích kiểu vãn bản -->
              <div class="explain-text-type">
                <ul class="explain-text-type__list">
                  <li *ngFor="let item of seoTextTypes" style="font-size: 14px">
                    <ng-container *ngIf="item.tag">
                      - <b>{{ item.tag | translate }}</b> &#8594;
                    </ng-container>
                    <span>
                      {{ item.explain | translate }} 
                      <ng-container *ngIf="item.usage">
                        (<b style="color: red">{{ item.usage | translate }}</b>)
                      </ng-container>
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Nội dung -->
            <div *ngIf="!config.is_copyright" class="config-text" style="width: 100%">
              <mat-form-field style="width: 100%">
                <mat-label>{{'noi_dung' | translate}}</mat-label>
                <textarea matInput
                  [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                  (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
                  (blur)="handleChangeConfig()"></textarea>
              </mat-form-field>
            </div>

            <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
              [config]="config" [staticdata]="staticdata" [textContentClass]="class['text__content']"
              [textWrapperClass]="class['text__wrapper']">
            </app-text-format-config>
            <div class="config-name">
              <p>{{'xuong_dong' | translate}}</p>
              <nz-switch [ngModel]="class['text__wrapper']['white-space'] && class['text__wrapper']['white-space'] !== 'nowrap'"
              (ngModelChange)="class['text__wrapper']['white-space'] = $event ? 'pre-wrap' : 'nowrap';updateClass()"></nz-switch>
            </div>

            <!-- Gradient -->
            <div class="config-font">
              <div class="config-name">
                <p>{{'do_mau_gradient' | translate}} <span style="font-size:13px">({{'da_sac' | translate}})</span></p>
                <nz-switch [(ngModel)]="config['background-image']['gradient_check']"
                  (ngModelChange)="handleSetGradientText()">
                </nz-switch>
              </div>
              <div class="container-gradient" *ngIf="config['background-image']['gradient_check']">
                <div class="list-gradient">
                  <button class="btn-gradient"
                    *ngFor="let bgGradient of config['background-image']['background_image_arr_gradient']; let i = index"
                    (click)="deleteGradient(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                    [disabled]="!config['background-image']['gradient_check']">
                    <i class="delete-icon bi bi-x-circle"></i>
                  </button>
                </div>
                <p class="title-head">{{'them_mau' | translate}}</p>
                <div class="container_add-gradient">
                  <button class="btn-add-gradient" [disabled]="!config['background-image'].gradient_check"
                    (click)="openbgGradient()" (blur)="addGradient()">
                    <input nz-input type="color" class="picking-gradient" id="input-gradient"
                      [(ngModel)]="config['background-image']['background_image_background_color']">
                    <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                  </button>
                  <div class="slide_container-gradient">
                    <input type="range" min="1" max="100"
                      [value]="config['background-image']['background_image_opacity']" class="slider-gradient"
                      (blur)="getValueRangeBackgroundGradient($event)"
                      [disabled]="!config['background-image'].gradient_check"
                      [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
                  </div>
                  <div class="value-range">{{config['background-image']['background_image_opacity']}}%</div>
                </div>
                <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
                <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
                  nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)"
                  [disabled]="!config['background-image'].gradient_check"
                  [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
                  [ngClass]="{ 'active': config['background-image']['background_image_direction'] === type.direction}">
                </button>
              </div>
            </div>
            <!-- Kiểu danh sách đầu dòng, đánh số -->
            <div class="config-font" *ngIf="!config.icon.icon_check">
              <p class="title" style="line-height:1.5">{{'kieu_danh_sach_dau_dong_danh_so' | translate}}</p>
              <div class="font">
                <!-- Disc -->
                <button class="font-text-btn" title="ordered-list" nz-button [disabled]="config['curve']['isCurve']"
                  (click)="handleListStyle('disc')"
                  [nzType]="class['text__content--list-style']['list-style'] === 'disc inside none' ? 'primary' : 'default' ">
                  <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
                </button>
                <!-- Decimal -->
                <button class="font-text-btn" title="unordered-list" nz-button [disabled]="config['curve']['isCurve']"
                  (click)="handleListStyle('decimal')"
                  [nzType]="class['text__content--list-style']['list-style'] === 'decimal inside none' ? 'primary' : 'default'">
                  <i nz-icon nzType="ordered-list" nzTheme="outline"></i>
                </button>
                <!-- Alpha -->
                <button class="font-text-btn" title="alpha-list" nz-button [disabled]="config['curve']['isCurve']"
                  (click)="handleListStyle('upper-alpha')"
                  [nzType]="class['text__content--list-style']['list-style'] === 'upper-alpha inside none' ? 'primary' : 'default'">
                  <i class="anticon anticon-ordered-list">
                    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 1920 1920"
                      xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M546.15 1603.617h1360v-120h-1360v120Zm0-1121.001h1360v-120h-1360v120Zm0 561h1360v-120h-1360v120ZM271.675 429.5 234.55 319.775c-2.75-6.967-5.683-15.171-8.8-24.613-3.117-9.441-6.233-19.662-9.35-30.662-2.75 11.183-5.683 21.542-8.8 31.075-3.117 9.533-6.05 17.783-8.8 24.75L161.95 429.5h109.725ZM419.35 582.675H347.3c-8.067 0-14.575-1.879-19.525-5.638-4.95-3.758-8.708-8.57-11.275-14.437l-23.65-69.85H140.5l-23.65 69.85c-2.017 5.133-5.637 9.762-10.862 13.887-5.226 4.126-11.688 6.188-19.388 6.188H14L169.1 182h95.15l155.1 400.675ZM230.325 1112.55c12.283 0 22.321-1.558 30.112-4.675 7.792-3.117 13.888-7.15 18.288-12.1 4.4-4.95 7.425-10.541 9.075-16.775a73.843 73.843 0 0 0 2.475-18.975c0-7.333-.963-13.933-2.887-19.8-1.925-5.866-5.226-10.816-9.9-14.85-4.676-4.034-10.863-7.15-18.563-9.35-7.7-2.2-17.416-3.3-29.15-3.3h-64.9v99.825h65.45Zm-65.45-260.975v99h48.4c10.267 0 19.525-.733 27.775-2.2s15.262-4.033 21.038-7.7c5.775-3.667 10.175-8.708 13.199-15.125 3.025-6.417 4.538-14.483 4.538-24.2 0-9.533-1.192-17.462-3.575-23.788-2.383-6.324-6.05-11.412-11-15.262-4.95-3.85-11.229-6.6-18.838-8.25-7.608-1.65-16.637-2.475-27.087-2.475h-54.45ZM219.325 782c27.684 0 51.242 2.567 70.675 7.7s35.292 12.375 47.575 21.725c12.283 9.35 21.221 20.716 26.813 34.1 5.591 13.384 8.387 28.325 8.387 44.825 0 8.983-1.283 17.646-3.85 25.987-2.567 8.342-6.6 16.134-12.1 23.375-5.5 7.242-12.558 13.888-21.175 19.938-8.616 6.05-18.975 11.275-31.075 15.675 26.4 6.417 45.925 16.775 58.575 31.075 12.65 14.301 18.975 32.816 18.975 55.55 0 17.05-3.3 32.909-9.9 47.575-6.6 14.667-16.271 27.454-29.012 38.362-12.742 10.909-28.463 19.434-47.163 25.575-18.7 6.142-40.058 9.213-64.075 9.213H71.925V782h147.4Zm126.65 847c2.2 0 4.4.412 6.6 1.238 2.2.825 4.308 2.246 6.325 4.262l36.85 38.775c-16.133 21.084-36.346 36.987-60.637 47.713-24.292 10.724-53.03 16.087-86.213 16.087-30.433 0-57.704-5.179-81.812-15.538-24.109-10.358-44.551-24.658-61.326-42.9-16.774-18.241-29.654-39.874-38.637-64.899-8.984-25.026-13.475-52.204-13.475-81.538 0-29.883 4.858-57.337 14.575-82.363 9.717-25.024 23.375-46.612 40.975-64.762s38.683-32.267 63.25-42.35c24.567-10.083 51.608-15.125 81.125-15.125 15.033 0 29.196 1.329 42.487 3.987 13.292 2.658 25.713 6.325 37.263 11 11.55 4.675 22.183 10.313 31.9 16.913 9.717 6.6 18.333 13.75 25.85 21.45l-31.35 42.075c-2.017 2.567-4.4 4.904-7.15 7.012-2.75 2.109-6.6 3.163-11.55 3.163-3.3 0-6.417-.733-9.35-2.2-2.933-1.466-6.05-3.255-9.35-5.363a1772.26 1772.26 0 0 0-10.862-6.875c-3.942-2.475-8.617-4.767-14.026-6.875-5.408-2.107-11.733-3.895-18.974-5.362-7.242-1.467-15.721-2.2-25.438-2.2-15.4 0-29.471 2.841-42.213 8.525-12.741 5.684-23.741 13.979-33 24.888-9.258 10.908-16.408 24.291-21.449 40.149-5.042 15.858-7.563 33.963-7.563 54.313 0 20.534 2.796 38.775 8.387 54.725 5.592 15.95 13.2 29.379 22.825 40.287 9.625 10.908 20.855 19.204 33.688 24.888 12.833 5.684 26.583 8.525 41.25 8.525 8.434 0 16.133-.413 23.1-1.238 6.967-.824 13.475-2.199 19.525-4.125 6.05-1.925 11.733-4.491 17.05-7.699 5.317-3.209 10.725-7.288 16.225-12.238a32.536 32.536 0 0 1 7.15-4.538c2.567-1.191 5.225-1.787 7.975-1.787Z"
                          fill-rule="evenodd"></path>
                      </g>
                    </svg>
                  </i>
                </button>
                <!-- Roman -->
                <button class="font-text-btn" title="roman-list" nz-button [disabled]="config['curve']['isCurve']"
                  (click)="handleListStyle('upper-roman')"
                  [nzType]="class['text__content--list-style']['list-style'] === 'upper-roman inside none' ? 'primary' : 'default'">
                  <i class="anticon anticon-ordered-list">
                    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 1920 1920"
                      xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="m368 585.675h93.5v-400.675h-93.5zm271-101h1280v-120h-1280zm-270.725 700h93.5v-400.675h-93.5zm-185.05 0h93.5v-400.675h-93.5zm455.775-139h1280v-120.001h-1280zm-270.775 689h93.5v-400.676h-93.5zm-184 0h93.5v-400.676h-93.5zm-183.225 0h93.5v-400.676h-93.5v400.676zm638-129h1280v-120h-1280z"
                          fill-rule="evenodd"></path>
                      </g>
                    </svg>
                  </i>
                </button>
              </div>
            </div>
          </div>

          <div class="field-row">
            <div class="config-font" style="margin-top:20px">
              <!-- Khoảng cách chữ -->
              <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classLetterSpacing]="class['text__content']" (updateClass)="updateClass()">
              </app-letter-spacing-config>

              <!-- Khoảng cách dòng -->
              <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classLineHeight]="class['text__content']" (updateClass)="updateClass()">
              </app-line-height-config>

              <!-- Độ nghiêng chữ -->
              <div>
                <div class="config-name mb-0">
                  <p>{{'xoay_chu' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="360" [nzStep]="1" [(ngModel)]="config['transform']['rotate']"
                    (ngModelChange)="handleSetTextRotate()" (nzBlur)="updateClass(); updateConfig()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="360" [nzStep]="1" [(ngModel)]="config['transform']['rotate']"
                      (ngModelChange)="handleSetTextRotate()" (nzOnAfterChange)="updateClass(); updateConfig()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </div>
              <ng-container *ngIf="config['transform']['rotate'] > 0">
                <!-- Ẩn chữ -->
                <div>
                  <div class="config-name mb-0">
                    <p>{{'an_chu' | translate}}</p>
                    <nz-switch [ngModel]="class.text.overflow == 'hidden'"
                      (ngModelChange)="class.text.overflow = $event ? 'hidden' : 'visible'; updateClass()">
                    </nz-switch>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="field-row" *ngIf="config['text_type'] == 'Blockquote'">
            <!-- Blockquote - Thụt lề -->
            <div class="config-font">
              <div class="config-name mb-0">
                <p>{{'thut_le' | translate}}</p>
                <nz-input-number [nzMin]="1" [nzMax]="100" [ngModel]="class['text__content']['padding-left'] | vhnumber"
                  (ngModelChange)="class['text__content']['padding-left'] = $event+'px'" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="1" [nzMax]="100" [ngModel]="class['text__content']['padding-left'] | vhnumber"
                (ngModelChange)="class['text__content']['padding-left'] = $event+'px'"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
            <!-- Blockquote - Kích thước viền -->
            <div class="config-font">
              <div class="config-name mb-0">
                <p>{{'kich_thuoc_vien' | translate}}</p>
                <nz-input-number [nzMin]="1" [nzMax]="20"
                  [ngModel]="class['text__content']['border-left-width'] | vhnumber"
                  (ngModelChange)="class['text__content']['border-left-width'] = $event+'px'" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="1" [nzMax]="100" [ngModel]="class['text__content']['border-left-width'] | vhnumber"
                (ngModelChange)="class['text__content']['border-left-width'] = $event+'px'"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>
            <div class="config-font">
              <div class="config-name">
                <p>{{'mau_vien' | translate}}</p>
                <input class="input-color" type="button"
                  [style.background]="class['text__content']['border-left-color']" [cpOKButton]="true"
                  [(colorPicker)]="class['text__content']['border-left-color']" (colorPickerClose)="updateClass()" />
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- VĂN BẢN GỢI Ý -->
      <li nz-submenu [nzTitle]="'van_ban_goi_y' | translate" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <div class="editor-field my-0">
          <div class="editor-field-body">
            <div class="field-row my-0">
              <!-- Nội dung chữ -->
              <div class="config-font" style="width:100%">
                <mat-form-field style="width:100%">
                  <mat-label>{{'noi_dung' | translate}}</mat-label>
                  <textarea style="height:80px;background: #edf6fd;
                    padding:10px 6px;font-size:13px;border-top-left-radius:5px;
                    border-top-right-radius:5px" matInput [(ngModel)]="config['tooltip']"
                    (blur)="updateConfig()"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </li>

      <!-- VĂN BẢN PHỤ-->
      <li *ngIf="objectChoosing.component == 'AtwTextCalculateCustom'" nz-submenu [nzTitle]="'van_ban_phu' | translate" [(nzOpen)]="openMap.menu10"
        (nzOpenChange)="openHandler('menu10')">
        <div class="editor-field my-0">
          <div class="editor-field-body">
            <div class="field-row my-0">
              <!-- Nội dung chữ -->
              <div class="config-font" style="width:100%">
                <mat-form-field style="width:100%">
                  <mat-label>{{'noi_dung' | translate}}</mat-label>
                  <textarea style="height:80px;background: #edf6fd;
                    padding:10px 6px;font-size:13px;border-top-left-radius:5px;
                    border-top-right-radius:5px" matInput [(ngModel)]="config['text_sub']"
                    (blur)="updateConfig()"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </li>

      <!-- ------------------------------------------------------ PHONG CÁCH VÀ KIỂU CỌ ------------------------------------------------------ -->
      <li nz-submenu [nzTitle]="'phong_cach_va_kieu_co' | translate" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-text-style-config [device]="device" [config]="config" [class]="class"
          [textContentClass]="class['text__content']" [textWrapperClass]="class['text__wrapper']"
          [textCurveItemClass]="class['text__curve-item']" [textCurveClass]="class['text__curve']"
          [curveConfig]="config['curve']" [filterConfig]="config['filter']" [isShape]="true"
          [objectChoosing]="objectChoosing">
        </app-text-style-config>
      </li>

      <!-- ------------------------------------------------------------ HIỆU ỨNG ------------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'hieu_ung' | translate" [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <app-choose-animations-config [elementChoosing]="objectChoosing" [id_object]="objectChoosing._id"
          [device]="device" [class]="class" [config]="config" [staticdata]="staticdata" [cursorClass]="class['text']"
          [effect_hover]="effect_hover" [customize]="customize" (openAnimationDetail)="openAnimationDetail($event)"
          [effectFileUsing]="'text'">
        </app-choose-animations-config>
      </li>

      <!-- ---------------------------------------------------------- THÊM LIÊN KẾT ---------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'lien_ket' | translate" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-link-page-config [objectChoosing]="objectChoosing" [staticdata]="staticdata"
          [id_object]="objectChoosing._id" [dynamic_data]="objectChoosing.dynamic_data" [hasContact]="true">
        </app-link-page-config>
      </li>

      <!-- CÔNG THỨC -->
      <li *ngIf="objectChoosing.component == 'AtwTextCalculateCustom'" nz-submenu nzTitle="{{'cong_thuc' | translate}}"
        [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">

        <div class="formula-builder">
          <textarea #formulaBox [(ngModel)]="formulaDraft" placeholder="Nhập công thức, ví dụ: a + b * 2" rows="4"
            style="width: 100%; padding: 8px; border-radius: 4px; border: 1px solid #d9d9d9;">
          </textarea>

          <button class="w-100" nz-button nzType="primary" (click)="confirmFormula()" style="margin-top: 8px;">
            Xác nhận công thức
          </button>

          <div class="input-list">
            <nz-tag class="tag" *ngFor="let input of inputCalculateCustom" (click)="insertToFormula(input.name)">
              {{input.name}}
            </nz-tag>
          </div>
        </div>
      </li>

    </ul>
  </ng-container>


  <!-- -------------------------------------------------- Xem chi tiết cấu hình object --------------------------------------------------- -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="config['animation-selected'].id != '000000' && currentViewAll.index == 1">
      <app-animations-config [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata"
        [id_object]="objectChoosing._id" [customize]="customize">
      </app-animations-config>
    </div>

    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['text__content']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>